import Icon from '~/components/UI/Icon'

export default Icon
